<template>
  <div
    v-scroll-lock
    class="animate__animated animate__fadeIn fixed inset-0 flex flex-col items-center justify-end bg-black/50"
    :style="{
      'z-index': 11
    }"
    @click.self="handleClose"
  >
    <div
      ref="content"
      class="w-full max-w-screen-sm mx-auto rounded-t-3xl shadow-xl overflow-hidden"
    >
      <!-- This classes caused auth modal fast change issue. wtf???? -->
      <!-- animate__animated animate__slideInUp -->
      <slot />
    </div>
  </div>
</template>

<script>
import * as motion from 'motion'

export default {
  name: 'BaseBottomSheet',

  methods: {
    handleClose() {
      const el = this.$el

      // this.$refs.content.classList.add('animate__slideOutDown')

      motion
        .animate(el, { opacity: 0 }, { duration: 0.3 })
        .finished.then(() => {
          this.$emit('close')
        })
    }
  }
}
</script>
